import { Link } from 'react-router-dom';

import { QUERY_PARAMS, ROUTES, SECTION_VALUES } from 'constants/routes.constant';

import StoreDigitalAssetSection from 'routes/store/storeDigitalAssetSection/StoreDigitalAssetSection';
import StoreIntroSection from 'routes/store/storeIntroSection/StoreIntroSection';

import Button from 'components/buttons/Button';

import { useStorePackagesQuery, useWorldNftQuery } from 'hooks/queries';

const LandingNftSection = () => {
  const {
    data: storePackages,
    loading: storePackagesLoading,
    error: storePackagesError,
    ...storePackagesPagination
  } = useStorePackagesQuery();

  const { asset: featuredAsset, rawTradeData } = useWorldNftQuery();

  return (
    <div className="landing-nft-card-isolated tw-bg-[#143478] tw-py-[60px] lg:tw-py-[120px]">
      <StoreIntroSection featuredAsset={featuredAsset} rawTradeData={rawTradeData} />
      {storePackages.length > 0 && <div className="tw-h-[60px] lg:tw-h-[100px]" />}
      <StoreDigitalAssetSection
        title="Ready for"
        productName="NFT PACKAGES"
        suffix="?"
        description="Choose from exclusive bundles designed to maximize yield and unlock unique opportunities in the Reality DA Ecosystem."
        packages={storePackages}
        {...storePackagesPagination}
      />
      {storePackages.length > 0 && (
        <Link
          to={`${ROUTES.STORE}?${QUERY_PARAMS.SECTION}=${SECTION_VALUES.DIGITAL_ASSET_PACKAGES}`}
          className="tw-mt-[70px] tw-hidden tw-items-center tw-justify-center lg:tw-flex"
        >
          <Button text="See more packages" onClick={() => {}} size="medium" />
        </Link>
      )}
    </div>
  );
};

export default LandingNftSection;
